import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { take } from 'rxjs';

import { IAM_STATUS, IamConfigService } from '../services/iam-config.service';

@Injectable({
  providedIn: 'root',
})
export class IAMGuard {
  constructor(
    private router: Router,
    private location: Location,
    private iamConfigService: IamConfigService
  ) {}

  restrict() {
    const destination = this.router
      .currentNavigation()
      ?.extractedUrl?.toString();
    this.router
      .navigateByUrl('/app/access-denied', { skipLocationChange: true })
      .then(() => {
        this.location.replaceState(destination);
      });
  }

  canLoad(): Promise<boolean | UrlTree> {
    return new Promise((resolve) => {
      this.iamConfigService.dataStore.pipe(take(1)).subscribe((data) => {
        if (
          data?.iam?.status === IAM_STATUS.INTERNAL ||
          data?.iam?.status === IAM_STATUS.INTERNAL_DISCONNECTED ||
          data?.iam?.status === IAM_STATUS.INTERNAL_PENDING
        ) {
          resolve(true);
        } else {
          console.log(
            `[DEBUG IAM Guard]: Navigated to the Access Denied page because of the IAM config mismatch`
          );

          console.log('Current IAM Status:', data?.iam?.status);
          this.restrict();
          resolve(false);
        }
      });
    });
  }
}
